import React from 'react';

export default function CardTitle({children, style, ...props}) {
    return <h2 style={{textDecoration: 'underline', textShadow: '2px 2px #333333'}} {...props}>{children}</h2>;
}
